define('vspot-angular/resources/login-resource',[], function () {
    'use strict';

    return ['$resource', function ($resource) {
        // AngularJS allows us to define multiple parameters in the same portion of the URL template.
        // As long as you only use one parameter at a time, AngularJS will construct the RESTful resource properly.
        // For params, if it is prefixed with @, then the value of that parameter is extracted from the data object
        // (useful for non-GET operations). In other words, if :controller is defined, :id should not, and vice versa.
        return $resource('/login/:controller:id',
            {
                id: '@id',
                controller: '@controller'
            },
            {
                copyActivity: {
                    method: 'POST',
                    params: {
                        controller: 'copy_activity'
                    }
                },
                transferActivity: {
                    method: 'POST',
                    params: {
                        controller: 'transfer_activity'
                    }
                },
                emailSpecialRequestInquiry: {
                    method: 'POST',
                    params: {
                        controller: 'email_special_request_inquiry'
                    }
                },
                emailSpecialPricingInquiry: {
                    method: 'POST',
                    params: {
                        controller: 'email_special_pricing_inquiry'
                    }
                },
                emailAdvertisingRequest: {
                    method: 'POST',
                    params: {
                        controller: 'email_advertising_request'
                    }
                },
                emailClientFeedback: {
                    method: 'POST',
                    params: {
                        controller: 'email_client_feedback'
                    }
                },
                emailGeneralFeedback: {
                    method: 'POST',
                    params: {
                        controller: 'email_general_feedback'
                    }
                },
                emailImageFlag: {
                    method: 'POST',
                    params: {
                        controller: 'email_image_flag'
                    }
                },
                submitContactFormInfo: {
                    method: 'POST',
                    params: {
                        controller: 'submit_contact_form_info'
                    }
                },
                submitContactFormSupport: {
                    method: 'POST',
                    params: {
                        controller: 'submit_contact_form_support'
                    }
                },
                submitContactFormAdvertising: {
                    method: 'POST',
                    params: {
                        controller: 'submit_contact_form_advertising'
                    }
                },
                stripePremiumReg: {
                    method: 'POST',
                    params: {
                        controller: 'stripe_premiumreg'
                    }
                },
                handleEntry: {
                    method: 'POST',
                    params: {
                        controller: 'handleentry_ns_mobile'
                    }
                },
                logout: {
                    method: 'POST',
                    params: {
                        controller: 'logout'
                    }
                }
            }
        );
    }];
});
